import { useQuery } from "@tanstack/react-query";

import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";

import type { AppsColumnConfigDto } from "../../types/dto";

import { createAppsColumnConfigQuery } from "./options";

export const useAppsColumnConfigQuery = <T = AppsColumnConfigDto>(
    appOs: AppOperatingSystem | undefined,
    select?: (data: AppsColumnConfigDto) => T,
) => useQuery(createAppsColumnConfigQuery(appOs, select));
